import {lazy} from 'react';

export const BeReadyLikesLazy = lazy(() => import(/* webpackChunkName: "beReadyLikes" */ '.'));
